import React, { useState, useContext } from "react"
import { FirebaseContext } from "../../firebase"
import _ from "lodash"

import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"

// Hooks
import useLogs from "../../hooks/useLogs"

// Loaders
import { LoaderProgressBar } from "../../components/Loaders"

// assets
import logo from "../../assets/images/logo-white-text.png"
import styles from "../../styles/Login.module.css"

export default function Login(props) {
  const firebase = useContext(FirebaseContext)
  const [logsEnable, writeLog] = useLogs()

  const [user, setUser] = useState("")
  const [password, setPassword] = useState("")
  const [err, setErr] = useState(null)
  const [showLogin, setShowLogin] = useState(true)
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState(null)

  let actionCodeSettings = {
    // After password reset, the user will be give the ability to go back
    // to this page.
    url: window.location.origin,
    handleCodeInApp: false,
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      props.setFetching(true)
      const userGet = await firebase.signIn(user, password)
      if (logsEnable) {
        await writeLog({
          type: "info",
          component: "Auth",
          message: `User logged in: ${userGet.user.participant_id}`,
          stack: "",
        })
      }
    } catch (error) {
      props.incrementFailedAttempts()
      setErr(error.message)
    } finally {
      props.setFetching(false)
    }
  }

  const handleSubmitRecover = async (e) => {
    setLoading(true)
    e.preventDefault()
    try {
      await firebase.sendPasswordResetEmail(user, actionCodeSettings)
      if (logsEnable) {
        await writeLog({
          type: "info",
          component: "Auth",
          message: `User resets password: ${user}`,
          stack: "",
        })
      }
      const msgTxt = `If your email address is found, a password reset email has been sent. Please check junk/spam folders if you do not see this message.`
      setTimeout(() => setMsg(msgTxt), 2000)
      setTimeout(() => {
        setLoading(false)
        setShowLogin(true)
        setMsg(null)
      }, 10000)
    } catch (error) {
      setMsg(error)
      setLoading(false)
      setErr(error.message)
    }
  }

  //const logoutMsg = getSessStorage("logout")

  return (
    <div className="layout-login">
      <img src={logo} alt="RecoveryLink Logo" className="main-logo" />
      {showLogin && (
        <div className="login-container">
          <h2>Login</h2>
          {err && <div className="form-section">{err}</div>}
          <form onSubmit={handleSubmit} className="form-section">
            <div className="form-field">
              <label htmlFor="email" style={{marginBottom:"5px"}}>Email</label>
              <InputText
                id="email"
                type="email"
                onChange={({ target: { value } }) => setUser(_.trim(value))}
              />
            </div>
            <div className="form-field">
              <label htmlFor="pass" style={{marginBottom:"5px"}}>Password</label>
              <InputText
                id="pass"
                type="password"
                onChange={({ target: { value } }) => setPassword(value)}
              />
            </div>
            <Button label="Login" type="submit" className="btn" />
          </form>
          {props.errorLogin && (
            <span className={styles["password-reset-prompt"]}>
              {props.errorLogin.message}
            </span>
          )}
          {props.showResetPasswordPrompt && (
            <span className={styles["password-reset-prompt"]}>
              Too many failed attempts. Please reset your password.
            </span>
          )}
          <Button
            className={styles["plain-text-link"]}
            label="Forgot your password?"
            onClick={() => setShowLogin(false)}
          />
        </div>
      )}
      {!showLogin && (
        <div className="login-container">
          <h2>Reset your password</h2>
          {err && <div className={styles.err}>{err}</div>}
          <form onSubmit={handleSubmitRecover} className="form-section">
            <div className="form-field">
              <label htmlFor="email" style={{marginBottom:"10px"}}>
                Enter your email to receive a link to reset your password
              </label>
              <InputText
                id="email"
                type="email"
                onChange={({ target: { value } }) => setUser(_.trim(value))}
                disabled={loading}
              />
            </div>
            <Button
              label="Send Link"
              type="submit"
              className="btn"
              disabled={loading || _.isEmpty(user)}
            />
            {loading && (
              <div style={{ margin: "15px 0" }}>
                <LoaderProgressBar />
              </div>
            )}
            <div>{msg && msg}</div>
          </form>
          <Button
            className={styles["plain-text-link"]}
            onClick={() => setShowLogin(true)}
            type="button"
            label="Back to Login"
          />
        </div>
      )}
    </div>
  )
}
